<template>
  <div class="relative w-full h-full">
    <div class="absolute inset-y-0 left-0 flex items-center pl-3">
      <svg
        class="searchIcon fill-current text-gray-600"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.32 14.9l1.1 1.1c.4-.02.83.13 1.14.44l3 3a1.5 1.5 0 0 1-2.12 2.12l-3-3a1.5 1.5 0 0 1-.44-1.14l-1.1-1.1a8 8 0 1 1 1.41-1.41l.01-.01zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
      </svg>
    </div>
    <input
      type="text"
      @input="$emit('change', $event.target.value)"
      placeholder="Search by keywords"
      class="block w-full h-full bg-white focus:outline-none focus:border-gray-500 text-gray-900 rounded-lg pl-16 pr-4 py-2"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
};
</script>

<style lang="scss">
.searchIcon {
  height: 70%;
}
</style>
